import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { KeretService } from '../../keret.service';
import { MODUL_TEMAK, ModulTema, temaNev } from '../../modul-tema';

/**
 *  A MODUL TÉMÁJA – kipróbálás és kijelölés (modul-tema.ts).
 *
 *  Csak a modul adminja látja, és csak olyan modulban, amelyiknek van Fókusz-kerete. A gombok
 *  KIPRÓBÁLJÁK a témát (csak ebben a böngészőben); ha a kipróbált eltér a kijelölttől, a
 *  „Legyen ez a modul témája" gomb mindenkire érvényesíti.
 *
 *  Két helyen jelenik meg: Fókuszban a profil-lenyílóban, Klasszikusban a bal sávban (sötét).
 */
@Component({
  selector: 'app-tema-valaszto',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './tema-valaszto.component.html',
  styleUrls: ['./tema-valaszto.component.scss'],
})
export class TemaValasztoComponent {
  /** A bal sáv sötét hátterén világos betűk kellenek. */
  @Input() sotet = false;

  temak = MODUL_TEMAK;
  fut = false;

  constructor(public keret: KeretService) {}

  get k() { return this.keret.a; }
  get lathato(): boolean { return !!this.k?.temaValaszthato(); }
  get proba(): boolean { return !!this.k && this.k.tema() !== this.k.kijeloltTema(); }
  get kijeloltNev(): string { return temaNev(this.k?.kijeloltTema()); }

  valaszt(t: ModulTema) {
    if (!this.k || t === this.k.tema()) return;
    this.k.temaProba(t === this.k.kijeloltTema() ? null : t);
  }

  async ment() {
    if (!this.k || this.fut) return;
    this.fut = true;
    try { await this.k.temaMent(this.k.tema()); } finally { this.fut = false; }
  }
}
